import React from "react";
import TabImg1 from "../Assets/img/benifit-tab-img/img-1.svg";
import TabImg2 from "../Assets/img/benifit-tab-img/img-2.svg";
import TabImg3 from "../Assets/img/benifit-tab-img/img-3.svg";
import TabImg4 from "../Assets/img/benifit-tab-img/img-4.svg";
import TabImg5 from "../Assets/img/benifit-tab-img/img-5.svg";
import TabImg6 from "../Assets/img/benifit-tab-img/img-6.svg";

const WhatsBenifit = () => {
  return (
    <>
      <section className="benefit-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2 col-12">
              <div className="section-title">
                <h3>Your Need, Our Responsibilities</h3>
                <p>
                  Through out unnecessary platforms to save on operational costs
                  and time. We help you easily run and manage all segments of
                  your ISP, backed-up with professional features and branded
                  with your company’s identity.
                </p>
              </div>
            </div>
          </div>
          <div className="benefit-details-main">
            <div className="row">
              <div className="col-12">
                {/* <!-- Tab Menu --> */}
                <div className="benefit-tab-menu">
                  <div
                    className="menu-tab  list-group"
                    id="list-tab"
                    role="tablist"
                  >
                    <a
                      className="list-group-item nav-item active"
                      data-bs-toggle="list"
                      href="#tab1"
                      role="tab"
                    >
                      <span>
                        <i className="icofont-chart-growth"></i>
                      </span>
                    </a>
                    <a
                      className="list-group-item nav-item"
                      data-bs-toggle="list"
                      href="#tab2"
                      role="tab"
                    >
                      <span className="tab-text-title">
                        <i className="icofont-computer"></i>
                      </span>
                    </a>
                    <a
                      className="list-group-item nav-item"
                      data-bs-toggle="list"
                      href="#tab3"
                      role="tab"
                    >
                      <span className="tab-text-title">
                        <i className="icofont-support"></i>
                      </span>
                    </a>
                    <a
                      className="list-group-item nav-item"
                      data-bs-toggle="list"
                      href="#tab4"
                      role="tab"
                    >
                      <span className="tab-text-title">
                        <i class="icofont-copy-invert"></i>
                      </span>
                    </a>
                    <a
                      className="list-group-item nav-item"
                      data-bs-toggle="list"
                      href="#tab5"
                      role="tab"
                    >
                      <span className="tab-text-title">
                        <i className="fa fa-users"></i>
                      </span>
                    </a>
                    <a
                      className="list-group-item nav-item"
                      data-bs-toggle="list"
                      href="#tab6"
                      role="tab"
                    >
                      <span className="tab-text-title">
                        <i className="fa fa-database"></i>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-12">
                {/* <!-- Tab Details --> */}
                <div className="tab-details">
                  <div className="tab-content" id="nav-tabContent">
                    {/* <!-- Tab One --> */}
                    <div
                      className="tab-pane fade show active"
                      id="tab1"
                      role="tabpanel"
                    >
                      <div className="benefit-tab-content">
                        <div className="row">
                          <div className="col-lg-6 col-md-6 col-12">
                            <div className="benefit-main-content">
                              <h3 className="benifit-title">
                                Increase Cost Efficiency
                              </h3>
                              <p>
                                We believe businesses today require a
                                Cost-Effective Managed Solutions. ISP Digital
                                attempt to reduce your service and support
                                costs. It gives you improved quality of service
                                with work downtimes, so the efficiency of your
                                operations is increased. Proactively monitoring
                                your user, if any issues occured you can solve
                                these before clients concern. Ensuring the
                                security of your data. And More!
                              </p>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-12">
                            <div className="detail-content-image">
                              <img src={TabImg1} alt="#" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <!-- Tab Two --> */}
                    <div className="tab-pane fade" id="tab2" role="tabpanel">
                      <div className="benefit-tab-content">
                        <div className="row">
                          <div className="col-lg-6 col-md-6 col-12">
                            <div className="benefit-main-content">
                              <h3 className="benifit-title">
                                Leading Business Remotely
                              </h3>
                              <p>
                                In the Fourth Industrial Revolution, business is
                                in your hands no matter where you are. Every
                                business needs skilled people as well as an
                                intellectual system. ISP Digital enables
                                professionals to work from anywhere, at any
                                time, drastically increasing workforce
                                flexibility. It helps to track employees' tasks
                                and increase productivity.
                              </p>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-12">
                            <div className="detail-content-image">
                              <img src={TabImg2} alt="#" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <!-- Tab Three --> */}
                    <div className="tab-pane fade" id="tab3" role="tabpanel">
                      <div className="benefit-tab-content">
                        <div className="row">
                          <div className="col-lg-6 col-md-6 col-12">
                            <div className="benefit-main-content">
                              <h3 className="benifit-title">
                                Effective Client Communication
                              </h3>
                              <p>
                                Effective communication fosters trust with
                                others. When it comes to relationships,
                                communication is everything. Poor communication
                                can quickly lead to the demise of relationships,
                                while good communication can help to sustain
                                them in the long-term. Effective client
                                communication takes a good deal of practice and
                                effort. ISP Digital provide you the user
                                friendly designed portal for customers with web
                                and android version both. Where customer can pay
                                internet bill and they can notify problem via
                                their portal. It can be determine the
                                long-lasting relationships.
                              </p>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-12">
                            <div className="detail-content-image">
                              <img src={TabImg3} alt="#" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <!-- Tab Four --> */}
                    <div className="tab-pane fade" id="tab4" role="tabpanel">
                      <div className="benefit-tab-content">
                        <div className="row">
                          <div className="col-lg-6 col-md-6 col-12">
                            <div className="benefit-main-content">
                              <h3 className="benifit-title">
                                Reliable Account Management
                              </h3>
                              <p>
                                ISP Digital billing engine is one of our
                                best-loved features. The flexible software
                                offers support for monthly recurring bill,
                                automatic proration and more. All the power you
                                need, backed by proper accounting practices. To
                                make life even easier, ISP Digital integrates
                                with numerous external services. That means you
                                can automatically send out invoices to
                                customers, and even use your chosen payment
                                processor.
                              </p>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-12">
                            <div className="detail-content-image">
                              <img src={TabImg4} alt="#" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <!-- Tab Five --> */}
                    <div className="tab-pane fade" id="tab5" role="tabpanel">
                      <div className="benefit-tab-content">
                        <div className="row">
                          <div className="col-lg-6 col-md-6 col-12">
                            <div className="benefit-main-content">
                              <h3 className="benifit-title">
                                Improve Employees Productivity
                              </h3>
                              <p>
                                An intellectual system with the right tools and
                                equipment can boost your employees'
                                productivity. ISP Digital attempts to give you
                                an Online Task Management System, Individual
                                Portal for employee, Performance Graph etc which
                                helps to boost employees daily activities,
                                performance.
                              </p>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-12">
                            <div className="detail-content-image">
                              <img src={TabImg5} alt="#" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <!-- Tab Five --> */}
                    <div className="tab-pane fade" id="tab6" role="tabpanel">
                      <div className="benefit-tab-content">
                        <div className="row">
                          <div className="col-lg-6 col-md-6 col-12">
                            <div className="benefit-main-content">
                              <h3 className="benifit-title">Data Security</h3>
                              <p>
                                Protecting your client's data, proprietary
                                information is not something you can do by
                                anyone other than experienced cyber security
                                professionals. Our cybersecurity professionals
                                are custom-designed to safeguard your business
                                technology and data assets. ISP Digital ensure
                                secure data center and the daily bakcups.
                              </p>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-12">
                            <div className="detail-content-image">
                              <img src={TabImg6} alt="#" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <!-- End Tab Details --> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WhatsBenifit;
